import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/svgs/icon-dd-cart.svg")